import { postUsersMeV2OrganisationsCurrentByTypeResourcesSelector } from "./postUsersMeV2OrganisationsCurrentByTypeResourcesSelector";
import { postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector } from "./postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector";
import { getResourceGridDataFixedCacheKey } from "../../utils/helpers/fixedCacheKeys";
import { RootState } from "@/store/store";
import {
  PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse,
  PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse,
} from "@/services/cloudchipr.api";

export const gridResourceDataSelector = (
  state: RootState,
  masterGridId: string,
):
  | PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse
  | PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse
  | undefined => {
  const providersData =
    postUsersMeV2OrganisationsCurrentByTypeResourcesSelector(
      getResourceGridDataFixedCacheKey(masterGridId),
    )(state)?.data;

  const k8sData = postUsersMeOrganisationsCurrentK8SByTypeResourcesSelector(
    getResourceGridDataFixedCacheKey(masterGridId),
  )(state)?.data;

  return providersData ?? k8sData;
};
